import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { OpenDialogAddEditPracticePlaceComponent } from 'app/components/dialog/open-dialog-add-edit-practice-place/open-dialog-add-edit-practice-place.component';
import { OpenDialogDeleteElementComponent } from 'app/components/dialog/open-dialog-delete-element/open-dialog-delete-element.component';
import { PracticePlace } from 'app/shared/models/class/practice-place/PracticePlace';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { PracticePlaceService } from 'app/shared/services/practice-place/pratcice-place.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-table-practice-club-solo',
  templateUrl: './table-practice-club-solo.component.html',
  styleUrls: ['./table-practice-club-solo.component.scss']
})
export class TablePracticeClubSoloComponent extends SubscriptionBaseComponent implements OnInit {
  userConnected: any;
  clubCode: any;

  // @Input() clubCode: string;
  @Input() set update(value: boolean) {
    if (value) {
      this.getPracticePlaceByClub(this.clubCode);

    }
  }

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  displayedColumns: string[] = ['label', 'country', 'region', 'department', 'postalCode', 'city', 'address', 'edit'];
  dataSource: MatTableDataSource<PracticePlace>;

  length: number;
  pageSize = 50;
  // pageSizeOptions: number[] = [5, 10, 25, 50];
  pageSizeOptions: number[] = [50, 100, 150];
  pageEvent: PageEvent;

  color: ThemePalette = 'primary';
  newPracticeplace = new PracticePlace();

  constructor(
    private practicePlaceService: PracticePlaceService,
    private dialog: MatDialog,
    private dataService: DataService,
    private authService: AuthService,
    private uiService: UiService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private faIconService: FaiconService,

  ) {
    super();
  }

  ngOnInit() {
    this.initSub();
    this.initComponent();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  getId(element: PracticePlace, type: string): string {

    const id = {
      th: `practice_place_th_${element.practicePlaceKey}`,
      faicon: `practice_place_faicon_${element.practicePlaceKey}`,
      input: `practice_place_input_${element.practicePlaceKey}`
    };

    return id[type];
  }

  goEdit(action: string, el: PracticePlace): void {

    const dialogRef = this.dialog.open(OpenDialogAddEditPracticePlaceComponent, {
      data: { action, praticePlace: el }
    });

    dialogRef.afterClosed().subscribe({
      next: () => {
        this.dataService.updatePracticePlace$.next(true);
      }
    });

    // this.resetTableElement();

    // // const faicon = document.getElementById(`practice_place_faicon_${el.practicePlaceKey}`);
    // // const input = document.getElementById(`practice_place_input_${el.practicePlaceKey}`);
    // // const th = document.getElementById(`practice_place_th_${el.practicePlaceKey}`);

    // th.style.width = '40%';
    // faicon.style.display = 'none';
    // input.style.display = 'flex';


  }

  updatePracticePlace(el: PracticePlace): void {
    if (this.newPracticeplace !== null) {
      this.practicePlaceService.updatePracticePlace(this.newPracticeplace).subscribe({
        next: () => {
          this.resetTableElement();
          this.getPracticePlaceByClub(this.clubCode);
        }
      });
    } else {
      this.uiService.showSnackbar('Vous n\'avez pas indiqué d\'adresse.');
    }

  }

  resetTableElement(): void {
    this.newPracticeplace = new PracticePlace();
    this.dataSource.data.forEach((data) => {
      const faicon = document.getElementById(`practice_place_faicon_${data.practicePlaceKey}`);
      const input = document.getElementById(`practice_place_input_${data.practicePlaceKey}`);
      const th = document.getElementById(`practice_place_th_${data.practicePlaceKey}`);

      th.style.width = '10%';
      faicon.style.display = 'block';
      input.style.display = 'none';

    });
  }

  deletePracticePlace(el: PracticePlace): void {
    const data = {
      title: 'Supprimer un lieu de pratique',
      text: 'Voulez-vous supprimer ce lieu de pratique ?',
      action: 'deletePracticePlace',
      id: el.practicePlaceKey,
    };

    const dialogRef = this.dialog.open(OpenDialogDeleteElementComponent, {
      data
    });

    dialogRef.afterClosed().subscribe({
      next: () => {
        this.getPracticePlaceByClub(this.clubCode);
      }
    });
  }

  getAddressPracticePlace(event, practicePlace: PracticePlace): void {

    event.address_components.forEach(el => {
      switch (el.types[0]) {
        case 'street_number':
          this.newPracticeplace.box = el.long_name;
          break;
        case 'route':
          this.newPracticeplace.address = el.long_name;
          break;
        case 'locality':
          this.newPracticeplace.city = el.long_name;
          break;
        case 'postal_code':
          this.newPracticeplace.postalCode = el.long_name;
          break;

        default:
          break;
      }
    });

    this.newPracticeplace.practicePlaceKey = practicePlace.practicePlaceKey;
    this.newPracticeplace.latitude = event.geometry.location.lat();
    this.newPracticeplace.longitude = event.geometry.location.lng();
    this.newPracticeplace.clubCode = this.authService.getDecodedToken().club_code;

  }

  applyFilter(filterValue): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  private getPracticePlaceByClub(clubCode: string): void {
    this.practicePlaceService.getPracticePlaceByClub(clubCode).subscribe({
      next: praticePlace => {
        this.dataSource = new MatTableDataSource<PracticePlace>(praticePlace);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        // this.dataService.updatePracticePlace$.next(true);
      }
    });
  }

  private async initComponent() {
    this.userConnected = this.authService.getDecodedToken();
    this.clubCode = await this.route.snapshot.queryParams.clubCode && this.userConnected.role === 'admin' ?
      this.route.snapshot.queryParams.clubCode : this.userConnected.club_code;

    this.getPracticePlaceByClub(this.clubCode);

    // if (userConnected.role === 'club') {
    //   this.clubCode = userConnected.club_code;
    //   this.getPracticePlaceByClub();
    // }
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.updatePracticePlace$.subscribe({
          next: updatePracticePlace => {
            if (updatePracticePlace) {
              this.getPracticePlaceByClub(this.clubCode);

            }
          }
        })
      )
      .add(
        this.dataService.valueFilterPracticePlace$.subscribe({
          next: value => {
            this.applyFilter(value);
            this.cdr.detectChanges();
          }
        })
      );
  }

}
